import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_PETITION_UPDATE_EMAIL_PREVIEW_ENABLED = createFcmDetails(
	'petition_update_email_preview_enabled',
	{
		owner: 'Coral',
		context: 'petition update',
		description: 'Whether to display the "preview email" button on the create petition update page.',
		import: false,
	},
);
